module.exports = __webpack_public_path__ + "static/media/city_sightseeing.570f64f3.jpg";